import type { RemindMeRequest } from "@/modules/events/types/eventDetailsApi"

import { handleResponseNotOk } from "@/modules/apiRequests/handlers"
import { EVENT_DETAILS_PATH, REMIND_ME_ENDPOINT } from "@/modules/events/constants/api"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"

export const getRemindMe = async (params: RemindMeRequest): Promise<void> => {
  const { locale, hostname, id } = params

  return fetcher(`/${locale}${EVENT_DETAILS_PATH}${id}${REMIND_ME_ENDPOINT}`, {
    hostname,
    serviceDomain: "MONOLITH_API",
  })
    .then(handleResponseNotOk)
    .catch(handleFetchError(REMIND_ME_ENDPOINT, params))
}
